import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';

import { Usuario } from '../../../model/interface/Usuario';

@Injectable()
export class UsuarioService {

  usuario: Usuario;

  constructor(private http: Http) { }

  create(params: any) {

    return this.http.post(`${ environment.API_URL }clientes`,  params)
      .map(res => {

        this.usuario = res.json().data;
        return this.usuario;
      });
  }

  suscribir(email: string) {

    const params = {'email': email};

    return this.http.patch(`${ environment.API_URL }usuarios/suscribir`,  params)
      .map(res => {

        this.usuario = res.json().data;
        return this.usuario;
      });
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/usuario/usuario.service.ts